<script lang="ts">
    import { Icon } from 'framework7-svelte';
    import { createEventDispatcher } from 'svelte';
    import { _ } from 'svelte-i18n';
    
    import RouteSelector from '../menu-buttons/RouteSelector.svelte';
    import DaySelector from './DaySelector.svelte';
    import TimeSelector from './TimeSelector.svelte';
    import DateSelector from './DateSelector.svelte';
    import type {DashboardTimeRange} from "../../types/filters/dashboard-time-range.type";
    import type {DashboardDateRange} from "../../types/filters/dashboard-date-range.type";
    import type {DashboardMeasurementFilter} from "../../types/filters/dashboard-measurement-filter.type";

    const dispatch = createEventDispatcher<{ selected: Date }>();
    
    let resetRoutes: boolean = false;    
    let resetDates: boolean = false;   
    let resetTime: boolean = false;  
    let resetDays: boolean = false; 
    
    let activeFilter = setDefaultFilter();
    
    function setDefaultFilter(): DashboardMeasurementFilter {
        return {
            dateRange: {
                startDate: undefined,
                endDate: undefined
            },
            timeRange: {
                startTime: undefined,
                endTime: undefined
            },
            weekdays: ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo']
        }

    }
    
    const handleChangeDays = (e: CustomEvent<string[]>) => {
        if(    
            activeFilter.weekdays.length === e.detail.length &&
            activeFilter.weekdays.every((day) => e.detail.includes(day))
        ) return;
        
        activeFilter.weekdays = e.detail;
        dispatch('changeFilter', activeFilter);
    };

    const handleChangeTime = (e: CustomEvent<DashboardTimeRange>) => {
        if(activeFilter.timeRange.startTime == e.detail.startTime && activeFilter.timeRange.endTime == e.detail.endTime) return;
        
        activeFilter.timeRange = e.detail;
        dispatch('changeFilter', activeFilter);
    };

    const handleChangeDate = (e: CustomEvent<DashboardDateRange>) => {
        if(activeFilter.dateRange.startDate == e.detail.startDate && activeFilter.dateRange.endDate == e.detail.endDate) return;
        
        activeFilter.dateRange = e.detail;
        dispatch('changeFilter', activeFilter);
    };

    const handleClearFilters = () => {
        resetRoutes = true;
        resetDates = true;   
        resetTime = true;  
        resetDays = true;

        activeFilter = setDefaultFilter();
        dispatch('changeFilter', activeFilter);
    };
</script>

<div class="card">
    <div class="card-content">
        <div class="card-dropdown">
            <span class="label">Route</span>
            <RouteSelector bind:resetRoutes />
        </div>
        <div class="card-dropdown">
            <span class="label">{$_('pages.dashboard.DATE')}</span>
            <DateSelector bind:resetDates on:change={handleChangeDate} />
        </div>
        <div class="card-dropdown">
            <span class="label">{$_('pages.dashboard.TIME')}</span>
            <TimeSelector bind:resetTime on:change={handleChangeTime} />
        </div>
        <div class="card-dropdown">
            <span class="label">{$_('pages.dashboard.DAY')}</span>
            <DaySelector bind:resetDays on:change={handleChangeDays} />
        </div>
        <div class="reset" on:click={handleClearFilters} on:keydown={handleClearFilters}>
            <Icon material="refresh" />
        </div>
    </div>
</div>

<style lang="scss">
    .reset {
        cursor: pointer;
    }

    .card-content {
        padding: 16px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 1rem;
        align-items: center;

        .card-dropdown {
            flex: 1;
        }

        .label {
            display: block;
            font-weight: 400;
            margin-bottom: 8px;
        }
    }
</style>
